import { gql } from "@apollo/client";

export const UPDATE_KETOSTERIL = gql`
    mutation UpdateKetoRI(
        $input: AddKetosterilRIInput!)
    {
        createAndUpdateKetosterilRI(
            input: $input
        ){
            idKetosterilRI
        }
    }
`;